import { ModalResultInterface } from "@nts/std/interfaces";

export class ModalResult<TResult> implements ModalResultInterface<TResult> {
  constructor(public result: TResult, public cancel = false) { }
}
